var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSalvar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6129 7.01556C12.9432 7.34918 12.9432 7.89008 12.6129 8.2237L10.1157 10.7463C9.39946 11.4698 8.23911 11.4728 7.51925 10.7529L6.61198 9.84569C6.28005 9.51376 6.27734 8.97287 6.60592 8.63756C6.93451 8.30226 7.46997 8.29952 7.8019 8.63145L8.70918 9.5387C8.76754 9.59706 8.86163 9.59682 8.9197 9.53816L11.4169 7.01556C11.7472 6.68194 12.2827 6.68194 12.6129 7.01556Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28457 1.7C5.33573 1.7 2.13457 4.90116 2.13457 8.85C2.13457 12.7988 5.33573 16 9.28457 16C13.2334 16 16.4346 12.7988 16.4346 8.85C16.4346 4.90116 13.2334 1.7 9.28457 1.7ZM0.43457 8.85C0.43457 3.96228 4.39685 0 9.28457 0C14.1723 0 18.1346 3.96228 18.1346 8.85C18.1346 13.7377 14.1723 17.7 9.28457 17.7C4.39685 17.7 0.43457 13.7377 0.43457 8.85Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSalvar);
export default __webpack_public_path__ + "static/media/icon_salvar.bdf4f0db715dfe3dfabad295b2d02c2b.svg";
export { ForwardRef as ReactComponent };